<div class="simulator-bar hide1" *ngIf="rootScope.simulationData.isSimulationModeActive">
  <p>Simulation Mode</p>
</div>
<div class="environment-bar hide1" *ngIf="rootScope.invalidENVBanner&&rootScope.isGenesysLoggedIn">
  <p>{{rootScope.Prod_lifeCycle ? constants.PROD_ENV_BANNER:constants.TEST_ENV_BANNER}}</p>
</div>
<div class="header-gradient"></div>
<div class="header" (window:resize)="rootScope.onResize()">
  <div class="divider main-tab">
    <div class="container">
      <div class="row">
        <div class="col-md-3 col-lg-2 logo-section">
          <img class="logo" src="../../../../assets/images/Logo.png" width="auto" height="auto" alt="Alight Care Portal" />
        </div>
        <div class="col-md-9 col-lg-10 flex justify-space-between flex-1">
          <div class="tab-container">
            <nav mat-tab-nav-bar aria-labelledby="mainnavheading" disableRipple>
              <button mat-tab-link *ngFor="let mainTab of rootScope.items" (click)="onTabChange(mainTab)"  [disabled]="mainTab.id === 'administration' && (rootScope.isLiveCall || rootScope.checkLiveChatAccount())"
                [active]="rootScope.activeLink === mainTab.id" [title]="mainTab.name | titlecase">
               <span [ngClass]="{'frozen': mainTab.id === 'administration' && (rootScope.isLiveCall || rootScope.checkLiveChatAccount())}">{{ mainTab.name }}</span>
              </button>
            </nav>
            <mat-tab-nav-panel #tabPanel></mat-tab-nav-panel>
          </div>
          <div class="right-section flex">            
            <div class="indicator-container" *ngIf="rootScope.loadUI">
              <span [ngClass]="{
                  green: indicatorClass === 'green',
                  gray: (indicatorClass === 'gray' || rootScope.indicatorClass ==='gray'),
                  red: (indicatorClass === 'red'||rootScope.indicatorClass==='red')
                }">
                <f-icon title="Genesys Cloud Indicator" icon-config='{"iconName": "cloud", "iconType": "solid", "iconSize": "m"}'></f-icon>
              </span>
              <span [ngClass]="{
                  green: tbaIndicatorClass === 'green',
                  gray: tbaIndicatorClass === 'gray',
                  red: tbaIndicatorClass === 'red'
                }">
                <f-icon title="TBA Indicator" icon-config='{"iconName": "satellite-dish", "iconType": "light", "iconSize": "m"}'></f-icon>
              </span>
              <span [ngClass]="{
                  green: networkIndicatorClass === 'green',
                  yellow: networkIndicatorClass === 'yellow',
                  red: networkIndicatorClass === 'red'
                }">
                <f-icon title="Network Connectivity" icon-config='{"iconName": "signal-bars", "iconType": "solid", "iconSize": "m"}'></f-icon>
              </span>
              <span *ngIf="rootScope?.utilityStatusClass===''"><f-icon title="Runtime Utility Indicator" icon-config='{"iconName": "gears", "iconType": "light", "iconSize": "l"}'></f-icon></span>
              <span *ngIf="rootScope?.utilityStatusClass==='red'"><f-icon title="Runtime Utility Indicator" icon-config='{"iconName": "gears", "iconType": "solid", "iconSize": "l", "iconColor": "#c61a1a"}'></f-icon></span>
              <span *ngIf="rootScope?.utilityStatusClass==='green'"><f-icon title="Runtime Utility Indicator" icon-config='{"iconName": "gears", "iconType": "solid", "iconSize": "l", "iconColor": "green"}'></f-icon></span>
            </div>
            <app-user-profile-data-card class="flex"></app-user-profile-data-card>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div *ngIf="rootScope.activeLink === 'search'" class="childnav">
    <div class="childnav-container container">
      <nav mat-tab-nav-bar disableRipple aria-labelledby="secondnavheading" class="nav-left"  [disablePagination]="true">
        <span *ngFor="let tab of rootScope.customerTabs; let index = index">
          <button *ngIf="(tab.id === 0 || tab.id === 1)" mat-tab-link [ngClass]="getClassByValue(tab)"
            (click)="onSecondTabChange(tab.customerSessionId, $event,tab)"
            [active]="rootScope.customerLink.toString() === tab.customerSessionId.toString()">
            <span *ngIf="tab.iconClass ==='light'&&tab.active&&liveIcon(tab, 'call')">
              <f-icon [ngClass]="tab.iconClass" [iconConfig]="{iconName: 'phone', iconType: 'light', iconSize: 'm'}"></f-icon>
            </span>
            <span *ngIf="tab.iconClass ==='red'&&tab.active&&liveIcon(tab, 'call')">
              <f-icon [ngClass]="tab.iconClass" [iconConfig]="{iconName: 'phone', iconType: 'solid', iconSize: 'm'}"></f-icon>
            </span>
            <span *ngIf="tab.iconClass ==='green'&&tab.active&&liveIcon(tab, 'call')">
              <f-icon [ngClass]="tab.iconClass" [iconConfig]="{iconName: 'phone', iconType: 'solid', iconSize: 'm'}"></f-icon>
            </span>
            <span *ngIf="callHollowIcon(tab)">
              <f-icon [ngClass]="tab.iconClass" [iconConfig]="{iconName: 'phone', iconType: 'light', iconSize: 'm'}"></f-icon>
            </span>
            <span *ngIf="chatHollowIcon(tab)">
              <f-icon [ngClass]="(tab.iconClass==='red' || tab.CS_SECURITY_LEVEL==='1')?'red':'green'" [iconConfig]="{iconName: 'comment', iconType: 'light', iconSize: 'm'}"></f-icon>
            </span>
            <span *ngIf="tab.iconClass === 'solid green'&&tab.active&& liveIcon(tab, 'chat')">
              <f-icon [ngClass]="tab.iconClass" [iconConfig]="{iconName: 'comment', iconType: 'solid', iconSize: 'm'}"></f-icon>
            </span>
            <span *ngIf="tab.iconClass === 'solid red'&&tab.active&& liveIcon(tab, 'chat')">
              <f-icon [ngClass]="tab.iconClass" [iconConfig]="{iconName: 'comment', iconType: 'solid', iconSize: 'm'}"></f-icon>
            </span>
            <span
              *ngIf="tab.iconClass !== 'solid green' && tab.iconClass !== 'solid red' &&tab.active && liveIcon(tab, 'chat')">
              <f-icon [ngClass]="tab.iconClass" [iconConfig]="{iconName: 'comment', iconType: 'light', iconSize: 'm'}"></f-icon>
            </span>
            <span *ngIf="tab.idle && !tab.additionalAccount && !rootScope?.checkCallOrChat()">
              <f-icon class="yellow" icon-config='{"iconName": "clock", "iconType": "light", "iconSize": "m"}'></f-icon></span>

            <span class="duplicate-tab-span" [title]="tab.title | titlecase">{{tab.title | titlecase
              }}</span>
            <f-icon class="duplicate-tab-span" icon-config='{"iconName": "magnifying-glass", "iconType": "light", "iconSize": "m"}' *ngIf="tab.customerSessionId === '0'"></f-icon>
            <button mat-icon-button *ngIf="hideCloseIcon(tab)" (click)="closeTab(index, $event, tab)">

              <f-icon icon-config='{"iconName": "xmark", "iconType": "solid", "iconSize": "s"}'></f-icon>

            </button>
          </button>
        </span>
      </nav>
  
      <nav mat-tab-nav-bar disableRipple aria-labelledby="thirdnavheading"
         [ngClass]="{'nav-right-for-unknown': checkForDuplicateSearch(),'nav-right': !checkForDuplicateSearch()}">
        <span *ngFor="let tab of rootScope.customerTabs; let index = index">
          <button *ngIf="!(tab.id === 0 || tab.id === 1)" mat-tab-link [disabled]="!tab.active && tab.id !== 0"
            [ngClass]="getClassByValue(tab)" (click)="onSecondTabChange(tab.customerSessionId, $event,tab)"
            [active]="rootScope.customerLink.toString() === tab.customerSessionId.toString()">
            <span *ngIf="tab.iconClass ==='light'&&tab.active&&liveIcon(tab, 'call')">
              <f-icon [ngClass]="tab.iconClass" [iconConfig]="{iconName: 'phone', iconType: 'light', iconSize: 'm'}"></f-icon>
            </span>
            <span *ngIf="tab.iconClass ==='red'&&tab.active&&liveIcon(tab, 'call')">
              <f-icon [ngClass]="tab.iconClass" [iconConfig]="{iconName: 'phone', iconType: 'solid', iconSize: 'm'}"></f-icon>
            </span>
            <span *ngIf="tab.iconClass ==='green'&&tab.active&&liveIcon(tab, 'call')">
              <f-icon [ngClass]="tab.iconClass" [iconConfig]="{iconName: 'phone', iconType: 'solid', iconSize: 'm'}"></f-icon>
            </span>
            <span *ngIf="callHollowIcon(tab)">
              <f-icon  [ngClass]="tab.iconClass" [iconConfig]="{iconName: 'phone', iconType: 'light', iconSize: 'm'}"></f-icon>
            </span>
            <span *ngIf="chatHollowIcon(tab)">
              <f-icon  [ngClass]="tab.iconClass" [iconConfig]="{iconName: 'comment', iconType: 'light', iconSize: 'm'}"></f-icon>
            </span>
            <span *ngIf="tab.iconClass === 'solid green'&&tab.active&& liveIcon(tab, 'chat')">
              <f-icon  [ngClass]="tab.iconClass" [iconConfig]="{iconName: 'comment', iconType: 'solid', iconSize: 'm'}"></f-icon>
            </span>
            <span *ngIf="tab.iconClass === 'solid red'&&tab.active&& liveIcon(tab, 'chat')">
              <f-icon [ngClass]="tab.iconClass" [iconConfig]="{iconName: 'comment', iconType: 'solid', iconSize: 'm'}"></f-icon>
            </span>
            <span
              *ngIf="tab.iconClass !== 'solid green' && tab.iconClass !== 'solid red' &&tab.active && liveIcon(tab, 'chat')">
              <f-icon  [ngClass]="tab.iconClass" [iconConfig]="{iconName: 'comment', iconType: 'light', iconSize: 'm'}"></f-icon>
            </span>
            <span *ngIf="tab.idle && !tab.additionalAccount && !rootScope?.checkCallOrChat()">
              <f-icon class="yellow" icon-config='{"iconName": "clock", "iconType": "light", "iconSize": "m"}'></f-icon></span>
            <span *ngIf="rootScope.customerLink !== tab.customerSessionId&&tab?.title" [title]="tab.title | titlecase">{{
              tab.title.length > rootScope.tabTitleChars &&
              tab.id !== 0 &&
              rootScope.customerLink !== tab.customerSessionId
              ? (tab.title | titlecase) : (tab.title | titlecase)
              }}</span>
            <span *ngIf="rootScope.customerLink === tab.customerSessionId" [title]="tab.title | titlecase">{{
              tab.title.length > rootScope.activeTabTitleChars && tab.id !== 0
              ? (tab.title | titlecase) : (tab.title | titlecase)
              }}</span>
      
            <f-icon icon-config='{"iconName": "magnifying-glass", "iconType": "light", "iconSize": "m"}' *ngIf="tab.customerSessionId === '0'"></f-icon>
            <button mat-icon-button *ngIf="hideCloseIcon(tab)" (click)="closeTab(index, $event, tab)">
              <f-icon icon-config='{"iconName": "xmark", "iconType": "solid", "iconSize": "s"}'></f-icon>
            </button>
          </button>
        </span>
      </nav>
    </div>
  </div>
<section class="error-wrapper hide">
  <f-alert variant="error">There was a problem accessing Simulation Mode. Try again by sliding the toggle to "On”.
  </f-alert>
</section>